import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/svgs/tax-loading.svg';
const _hoisted_1 = {
  class: "pc-container"
};
const _hoisted_2 = {
  class: "pc-content"
};
const _hoisted_3 = {
  class: "pc-left"
};
const _hoisted_4 = {
  class: "pc-right"
};
const _hoisted_5 = {
  class: "right-top"
};
const _hoisted_6 = {
  key: 0,
  class: "hubspot-form-wrapper"
};
const _hoisted_7 = {
  class: "hubspot-form-container"
};
const _hoisted_8 = {
  key: 0,
  class: "hubspot-form-loading"
};
const _hoisted_9 = {
  key: 0,
  class: "right-bottom"
};
const _hoisted_10 = {
  class: "submit"
};
import MembershipPrivilege from "@/components/membership-privilege";
import FleetsMembershipPrivilege from "@/components/fleets-membership-privilege";
import Step1 from "@/components/step-1";
import Step2 from "@/components/step-2";
import Step3 from "@/components/step-3";
import Step4 from "@/components/step-4";
import SuccessfulPage from "@/views/successful";
import SubscribedModal from "@/components/subscribed-modal";
import useNorthlandInsurance from "../mixin.js";
import { ACCOUNT_TYPE } from "@/const";
import { useProductStore } from "@/store/product";
export default /*@__PURE__*/Object.assign({
  name: "NorthlandInsurancePC"
}, {
  __name: 'pc',
  setup(__props) {
    const productStore = useProductStore();
    const {
      accountType,
      buttonLoading,
      pageLoading,
      showSuccessfulModal,
      showSubscribedModal,
      hubspotFormLoading,
      isFormValid,
      onAccountTypeChange,
      onStep2FormChange,
      onStep3FormChange,
      onStep4FormChange,
      submit,
      handleFormBlur,
      isTaxSuccess,
      taxLoading,
      taxAmount,
      isStep4Valid
    } = useNorthlandInsurance();
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(accountType) === _unref(ACCOUNT_TYPE).FLEET_MONTH ? (_openBlock(), _createBlock(_unref(FleetsMembershipPrivilege), {
        key: 0,
        "product-info": _unref(productStore).fleetProductInfo
      }, null, 8, ["product-info"])) : (_openBlock(), _createBlock(_unref(MembershipPrivilege), {
        key: 1,
        "product-info": _unref(productStore).membershipProductInfo
      }, null, 8, ["product-info"]))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(Step1), {
        ref: "step1",
        "onUpdate:accountType": _unref(onAccountTypeChange)
      }, null, 8, ["onUpdate:accountType"]), _unref(accountType) === _unref(ACCOUNT_TYPE).FLEET_MONTH ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "step2-title"
      }, [_createTextVNode("Step "), _createElementVNode("span", null, "2"), _createTextVNode(":")], -1)), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "form-title"
      }, "Fill out the form", -1)), _createElementVNode("div", _hoisted_7, [_unref(hubspotFormLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_icon, {
        class: "is-loading",
        size: "40"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("img", {
          src: _imports_0,
          alt: "loading"
        }, null, -1)])),
        _: 1,
        __: [2]
      }), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "hubspot-form-loading-text"
      }, "Loading form...", -1))])) : _createCommentVNode("", true), _cache[4] || (_cache[4] = _createElementVNode("div", {
        id: "hubspot-form-container"
      }, null, -1))])])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_unref(Step2), {
        ref: "step2",
        "onUpdate:form": _unref(onStep2FormChange),
        "onUpdate:formBlur": _unref(handleFormBlur)
      }, null, 8, ["onUpdate:form", "onUpdate:formBlur"]), _createVNode(_unref(Step3), {
        ref: "step3",
        "onUpdate:form": _unref(onStep3FormChange),
        "onUpdate:formBlur": _unref(handleFormBlur)
      }, null, 8, ["onUpdate:form", "onUpdate:formBlur"]), _createVNode(_unref(Step4), {
        ref: "step4",
        "onUpdate:form": _unref(onStep4FormChange),
        "tax-loading": _unref(taxLoading),
        "tax-amount": _unref(taxAmount),
        "is-form-valid": _unref(isFormValid),
        "product-info": _unref(productStore).membershipProductInfo
      }, null, 8, ["onUpdate:form", "tax-loading", "tax-amount", "is-form-valid", "product-info"])], 64))]), _unref(accountType) !== _unref(ACCOUNT_TYPE).FLEET_MONTH ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        loading: _unref(buttonLoading),
        disabled: !(_unref(isFormValid) && _unref(isStep4Valid)) || !_unref(isTaxSuccess),
        type: "primary",
        onClick: _unref(submit)
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("Place my order")])),
        _: 1,
        __: [7]
      }, 8, ["loading", "disabled", "onClick"])])])) : _createCommentVNode("", true)])]), _unref(showSuccessfulModal) ? (_openBlock(), _createBlock(_unref(SuccessfulPage), {
        key: 0
      })) : _createCommentVNode("", true), _createVNode(_unref(SubscribedModal), {
        modelValue: _unref(showSubscribedModal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(showSubscribedModal) ? showSubscribedModal.value = $event : null),
        onClose: _cache[1] || (_cache[1] = $event => showSubscribedModal.value = false)
      }, null, 8, ["modelValue"])])), [[_directive_loading, _unref(pageLoading)]]);
    };
  }
});